import type React from 'react';

import type { ErrorHandlerProps } from '#src/app/pages/decisionMakerResponse/details/pageContext';

export const DecisionMakerResponseErrorHandler: React.FC<ErrorHandlerProps> = ({ context: { error } }) => {
	throw new Error(`Failed to retrieve data for DecisionMakerResponse page (error: ${error})`);
};
